// @flow

import { get } from "lodash";
import wro from "@tvg/api/wro";
import type { RequestOptions, WroWager, WroResponse } from "@tvg/api/wro/types";

const getHorseNamesList = (bettingInterests) =>
  bettingInterests &&
  bettingInterests.map((selection) => selection?.runners?.[0].horseName);

export const formatBets = (wagers: WroWager[]) =>
  wagers
    .filter((wager) => get(wager, "betStatus.code") !== "C")
    .map((wager) => ({
      id: wager.serialNumber,
      raceTypeCode: wager.raceTypeAbbreviation,
      betTotal: wager.betTotal,
      horseNamesList: getHorseNamesList(
        wager.selections.selection[0].bettingInterests
      ),
      wagerAmount: wager.wagerAmount,
      wagerType: wager.wagerType,
      selections: wager.selections.selection.map((selection) =>
        selection.runners.map((runner) => runner.number.toString())
      ),
      isKey: false,
      isLeg: wager.wagerType.id < 400 && wager.wagerType.id > 300,
      isCancelled: wager.betStatus.code === "C",
      isLost: wager.betStatus.code === "L",
      isRefunded: wager.betStatus.code === "R",
      totalWinAmount:
        wager.betStatus.code === "W" ? wager.winningsAmount : undefined
    }));

const formatWroBets = (response: { data: WroResponse }) =>
  formatBets(response.data.wagers);

const getRaceBets = (options: RequestOptions, accountNumber: string) =>
  wro
    .getMyBets(options, accountNumber)
    .then((res) => {
      if (res.status === 200) {
        return formatWroBets(res);
      }
      return [];
    })
    .catch(() => []);

export default getRaceBets;
